/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DraftInputs */

const en_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const de_draft = /** @type {(inputs: DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {DraftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const draft = /** @type {((inputs?: DraftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DraftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft(inputs)
	return de_draft(inputs)
});